const expandedButtonElements = document.querySelectorAll('.js-expanded-button')

const handleButtonClick = (event) => {
  const button  = event.currentTarget
  const expanded = button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
  button.setAttribute('aria-expanded', expanded)
}

export const initExpandedButtons = () => {
  for (const button of expandedButtonElements) {
    button.addEventListener('click', handleButtonClick)
  }
}
